import axios from 'axios';
import { LocalStore } from '../storage/authStore';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const API_BASE = `${API_URL}/api/admin/web-category`;

// Get auth token
const getAuthHeader = () => {
  const details = LocalStore.getCurrentUserDetails();
  const token = details ? details.token : null;
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

export const subCategoryService = {
  // Get all subcategories from MongoDB
  getAllSubCategories: async (params = {}) => {
    try {
      // Add type=subcategory to ensure we fetch subcategories
      const response = await axios.get(API_BASE, {
        ...getAuthHeader(),
        params: { ...params, type: 'subcategory' }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching subcategories:', error);
      throw error;
    }
  },

  // Get subcategory by ID
  getSubCategoryById: async (id) => {
    try {
      const response = await axios.get(`${API_BASE}/${id}`, getAuthHeader());
      return response.data;
    } catch (error) {
      console.error('Error fetching subcategory:', error);
      throw error;
    }
  },

  // Get subcategory with child categories
  getSubCategoryWithChildren: async (id) => {
    try {
      const response = await axios.get(`${API_BASE}/${id}/full`, getAuthHeader());
      return response.data;
    } catch (error) {
      console.error('Error fetching subcategory with children:', error);
      throw error;
    }
  },

  // Create subcategory
  createSubCategory: async (data) => {
    try {
      const response = await axios.post(API_BASE, data, getAuthHeader());
      return response.data;
    } catch (error) {
      console.error('Error creating subcategory:', error);
      throw error;
    }
  },

  // Update subcategory
  updateSubCategory: async (id, data) => {
    try {
      const response = await axios.put(`${API_BASE}/${id}`, data, getAuthHeader());
      return response.data;
    } catch (error) {
      console.error('Error updating subcategory:', error);
      throw error;
    }
  },

  // Delete subcategory
  deleteSubCategory: async (id) => {
    try {
      const response = await axios.delete(`${API_BASE}/${id}`, getAuthHeader());
      return response.data;
    } catch (error) {
      console.error('Error deleting subcategory:', error);
      throw error;
    }
  },

  // Reorder subcategories
  reorderSubCategories: async (subCategories) => {
    try {
      const response = await axios.patch(
        `${API_BASE}/reorder`,
        { subCategories },
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error('Error reordering subcategories:', error);
      throw error;
    }
  },

  // ==================== SUBDATA (Location Content) Management ====================
  
  // Get subcategory with subData
  getSubCategoryWithSubData: async (id) => {
    try {
      const WEB_CATEGORY_BASE = `${API_URL}/api/admin/web-category`;
      const response = await axios.get(
        `${WEB_CATEGORY_BASE}/subcategory/${id}`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching subcategory with subData:', error);
      throw error;
    }
  },

  // Add location content (subData) to subcategory
  addSubDataToSubCategory: async (subCategoryId, subDataEntry) => {
    try {
      const WEB_CATEGORY_BASE = `${API_URL}/api/admin/web-category`;
      const response = await axios.post(
        `${WEB_CATEGORY_BASE}/subcategory/${subCategoryId}/subdata`,
        subDataEntry,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error('Error adding subData:', error);
      throw error;
    }
  },

  // Update location content in subcategory
  updateSubDataInSubCategory: async (subCategoryId, subdataIndex, subDataEntry) => {
    try {
      const WEB_CATEGORY_BASE = `${API_URL}/api/admin/web-category`;
      const response = await axios.put(
        `${WEB_CATEGORY_BASE}/subcategory/${subCategoryId}/subdata/${subdataIndex}`,
        subDataEntry,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error('Error updating subData:', error);
      throw error;
    }
  },

  // Delete location content from subcategory
  deleteSubDataFromSubCategory: async (subCategoryId, subdataIndex) => {
    try {
      const WEB_CATEGORY_BASE = `${API_URL}/api/admin/web-category`;
      const response = await axios.delete(
        `${WEB_CATEGORY_BASE}/subcategory/${subCategoryId}/subdata/${subdataIndex}`,
        getAuthHeader()
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting subData:', error);
      throw error;
    }
  }
};
